const createEmptySlot = (type) => {
  const slot = document.createElement("slot");
  slot.setAttribute("name", type);
  return slot;
};
const validateSlotRequirements = (element, type, isRequired) => {
  const errors = [];
  const slottedContent = element.querySelector(`[slot="${type}"]`);
  if (isRequired && !slottedContent) {
    errors.push(`Required slot "${type}" is missing in ${element.tagName}`);
  }
  return {
    isValid: errors.length === 0,
    errors
  };
};
const cloneWithoutSlotAttribute = (element) => {
  const clone = element.cloneNode(true);
  clone.removeAttribute("slot");
  return clone;
};
const processDefaultStyling = (element, slotRef) => {
  const elementRef = element.querySelector(
    `:scope > [slot=${slotRef}]`
  );
  if (!elementRef) {
    return null;
  }
  return elementRef.hasAttribute("styled") ? createEmptySlot(slotRef) : cloneWithoutSlotAttribute(elementRef);
};
const createSlot = ({
  element,
  type,
  isDefaultStyling = true,
  isRequired = false
}) => {
  const validation = validateSlotRequirements(element, type, isRequired);
  if (!validation.isValid) {
    return null;
  }
  const slottedContent = element.querySelector(`[slot="${type}"]`);
  if (!slottedContent) {
    return null;
  }
  return isDefaultStyling ? processDefaultStyling(element, type) : createEmptySlot(type);
};
export {
  createSlot
};
//# sourceMappingURL=create.js.map
